/**
 * Avatar utilisateur — remplace MUI Avatar.
 */
const Avatar = (props: {
    src?: string;
    name?: string;
    size?: number;
    className?: string;
}) => {
    const size = props.size || 36;
    const initials = (props.name || '?')
        .split(' ')
        .map(w => w[0])
        .slice(0, 2)
        .join('')
        .toUpperCase();

    return props.src ? (
        <img
            src={props.src}
            alt={props.name || ''}
            className={`rounded-full object-cover ${props.className || ''}`}
            style={{ width: size, height: size }}
        />
    ) : (
        <div
            className={`rounded-full bg-[var(--eb-primary-soft)] text-[var(--eb-primary)] flex items-center justify-center font-bold ${props.className || ''}`}
            style={{ width: size, height: size, fontSize: size * 0.4 }}
        >
            {initials}
        </div>
    );
};

export default Avatar;
